/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Tysiav2CheckCircle/view.blocks to change it.
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Tysiav2CheckCircle({
  children,
  viewPath = "/DesignSystem/Svgs/Tysiav2CheckCircle",
  alignSelf = "auto",
  marginTop = 0,
  marginBottom = 0,
  marginLeft = 0,
  marginRight = 0,
  opacity = 1,
  width = 14,
  height = 14,
  fill = "none",
  isAnimated,
  animation = "dash 5s linear forwards",
  strokeDashoffset = 1000,
  strokeDasharray = 1000,
  fill2 = "#3F9142"
  
}) {
  return (<React.Fragment
>
<svg
  data-testid="Tysiav2CheckCircle.Svg"
  data-view-path={viewPath}
 viewBox="0 0 14 14"
 style={{'--as-1-1u1E7j': alignSelf,'--mt-2-1u1E7j': typeof marginTop === 'number' ? `${marginTop}px` : marginTop,'--mb-3-1u1E7j': typeof marginBottom === 'number' ? `${marginBottom}px` : marginBottom,'--ml-4-1u1E7j': typeof marginLeft === 'number' ? `${marginLeft}px` : marginLeft,'--mr-5-1u1E7j': typeof marginRight === 'number' ? `${marginRight}px` : marginRight,'--o-6-1u1E7j': opacity,'--w-10-1u1E7j': typeof width === 'number' ? `${width}px` : width,'--h-11-1u1E7j': typeof height === 'number' ? `${height}px` : height,'--f-12-1u1E7j': fill,'--a-7-1u1E7j': isAnimated ? animation : "none",'--sd-8-1u1E7j': isAnimated ? strokeDashoffset : 0,'--sd-9-1u1E7j': isAnimated ? strokeDasharray : 0}}
 className={`views-block ${styles.Svg}`}
>
<g
  data-testid="Tysiav2CheckCircle.SvgGroup"
  data-view-path={viewPath}
 clipPath="url(#clip0_8777_5400)"
 className="views-block"
>
<path
  data-testid="Tysiav2CheckCircle.SvgPath"
  data-view-path={viewPath}
 fillRule="evenodd"
 clipRule="evenodd"
 d="M7 14A7 7 0 107 0a7 7 0 000 14zm3.503-8.781A.75.75 0 009.33 4.28L5.786 8.714 4.367 7.65a.75.75 0 10-.9 1.2l2 1.5a.75.75 0 001.036-.131l4-5z"
 style={{'--f-12-1u1E7j': fill2}}
 className={`views-block ${styles.SvgPath}`}
/>
</g>
</svg>
{children}
</React.Fragment>)
}